import { c as _c } from "react/compiler-runtime";
import { Badge, Box, Button, Circle, Heading, HStack, Icon, Presence, Progress, SkeletonCircle, SkeletonText, Spinner, Text, VStack, Wrap } from '@chakra-ui/react';
import { PulsatingText } from '@src/components/sco/Matching/UserSearchLoadingState';
import { usePitchDeckUpload } from '@src/components/sco/PitchDeckAuditor/hooks/usePitchDeckUpload';
import { ratingColorPalette } from '@src/components/sco/PitchDeckAuditor/model/ratingMeta';
import { PitchDeckView } from '@src/components/sco/PitchDeckAuditor/model/types';
import { IconType } from 'react-icons';
import { LuFileText, LuGauge, LuListChecks, LuRadar, LuRefreshCw, LuTriangleAlert, LuUpload } from 'react-icons/lu';
const STATUS_ORDER = ['uploaded', 'parsing', 'classified', 'auditing', 'audited'];
type Step = {
  title: string;
  detail: string;
  icon: IconType;
  statusIndex: number;
};
const STEPS: Step[] = [{
  title: 'Receiving your deck',
  detail: 'Securely storing your PDF',
  icon: LuUpload,
  statusIndex: 0
}, {
  title: 'Reading every slide',
  detail: 'Pulling text and structure from each page',
  icon: LuFileText,
  statusIndex: 1
}, {
  title: 'Matching slides to the canonical 9',
  detail: 'Classifying each slide against the framework',
  icon: LuListChecks,
  statusIndex: 2
}, {
  title: 'Scoring and building your report',
  detail: 'Whole deck + full rubric in one pass — cross-slide reasoning on',
  icon: LuGauge,
  statusIndex: 3
}];
export function PitchDeckProcessing(t0) {
  const $ = _c(73);
  const {
    deck
  } = t0;
  const {
    reanalyze,
    reanalyzing
  } = usePitchDeckUpload();
  let t1;
  if ($[0] !== deck.statusKey) {
    t1 = STATUS_ORDER.indexOf(deck.statusKey);
    $[0] = deck.statusKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const currentIndex = Math.max(0, t1);
  const progressPct = deck.isFailed ? 100 : Math.min(95, Math.round(currentIndex / STEPS.length * 100) + 8);
  const t2 = deck.slides;
  let T0;
  let T1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== currentIndex || $[3] !== deck.companyName || $[4] !== deck.errorMessage || $[5] !== deck.isFailed || $[6] !== deck.pitchDeckId || $[7] !== deck.slides || $[8] !== progressPct || $[9] !== reanalyze || $[10] !== reanalyzing) {
    t13 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const scoredSlides = t2.filter(_temp);
      if (deck.isFailed) {
        let t14;
        let t15;
        if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
          t14 = {
            base: 4,
            md: 10
          };
          t15 = {
            base: 6,
            md: 16
          };
          $[24] = t14;
          $[25] = t15;
        } else {
          t14 = $[24];
          t15 = $[25];
        }
        let t16;
        let t17;
        if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
          t16 = <Circle bg="red.subtle" size={14}><Icon as={LuTriangleAlert} boxSize={6} color="red.fg" /></Circle>;
          t17 = <Heading size="lg" textAlign="center">We couldn’t finish auditing this deck</Heading>;
          $[26] = t16;
          $[27] = t17;
        } else {
          t16 = $[26];
          t17 = $[27];
        }
        const t18 = deck.errorMessage || "Something went wrong while analyzing your deck. You can try the audit again.";
        let t19;
        if ($[28] !== t18) {
          t19 = <Text color="fg.muted" fontSize="sm" textAlign="center">{t18}</Text>;
          $[28] = t18;
          $[29] = t19;
        } else {
          t19 = $[29];
        }
        let t20;
        if ($[30] !== deck.pitchDeckId || $[31] !== reanalyze) {
          t20 = () => reanalyze(deck.pitchDeckId);
          $[30] = deck.pitchDeckId;
          $[31] = reanalyze;
          $[32] = t20;
        } else {
          t20 = $[32];
        }
        let t21;
        if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
          t21 = <LuRefreshCw />;
          $[33] = t21;
        } else {
          t21 = $[33];
        }
        let t22;
        if ($[34] !== reanalyzing || $[35] !== t20) {
          t22 = <Button loading={reanalyzing} variant="cta" onClick={t20}>{t21}Try again</Button>;
          $[34] = reanalyzing;
          $[35] = t20;
          $[36] = t22;
        } else {
          t22 = $[36];
        }
        let t23;
        if ($[37] !== t19 || $[38] !== t22) {
          t23 = <VStack gap={5} marginX="auto" maxWidth="620px" padding={t14} pt={t15} width="full">{t16}{t17}{t19}{t22}</VStack>;
          $[37] = t19;
          $[38] = t22;
          $[39] = t23;
        } else {
          t23 = $[39];
        }
        t13 = t23;
        break bb0;
      }
      T1 = VStack;
      t6 = 6;
      t7 = "auto";
      t8 = "680px";
      if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = {
          base: 4,
          md: 10
        };
        $[40] = t9;
      } else {
        t9 = $[40];
      }
      t10 = "full";
      let t14;
      if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = {
          base: 2,
          md: 6
        };
        $[41] = t14;
      } else {
        t14 = $[41];
      }
      let t15;
      if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = <Icon as={LuRadar} color="orange.fg" />;
        $[42] = t15;
      } else {
        t15 = $[42];
      }
      let t16;
      if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = <HStack color="fg.muted" gap={2}>{t15}<Heading size="xs">Status: <PulsatingText isActive={true}>Analyzing your deck</PulsatingText></Heading></HStack>;
        $[43] = t16;
      } else {
        t16 = $[43];
      }
      let t17;
      if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = {
          base: "lg",
          md: "xl"
        };
        $[44] = t17;
      } else {
        t17 = $[44];
      }
      const t18 = deck.companyName ? `Reading ${deck.companyName}` : "Reading your deck";
      if ($[45] !== t18) {
        t11 = <VStack align="stretch" gap={2} pt={t14} width="full">{t16}<Box fontSize={t17} fontWeight="600">{t18} — pulling every slide, matching each one to the canonical 9, and grading the whole deck in a single pass so the feedback can reason across slides.</Box></VStack>;
        $[45] = t18;
        $[46] = t11;
      } else {
        t11 = $[46];
      }
      let t19;
      if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = <Progress.Track borderRadius="full"><Progress.Range /></Progress.Track>;
        $[47] = t19;
      } else {
        t19 = $[47];
      }
      let t20;
      if ($[48] !== progressPct) {
        t20 = <Progress.Root colorPalette="orange" size="sm" value={progressPct}>{t19}</Progress.Root>;
        $[48] = progressPct;
        $[49] = t20;
      } else {
        t20 = $[49];
      }
      let t21;
      if ($[50] !== progressPct) {
        t21 = <Text>{progressPct}%</Text>;
        $[50] = progressPct;
        $[51] = t21;
      } else {
        t21 = $[51];
      }
      let t22;
      if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = <Text>The full audit usually takes about 60 seconds</Text>;
        $[52] = t22;
      } else {
        t22 = $[52];
      }
      let t23;
      if ($[53] !== t21) {
        t23 = <HStack color="fg.subtle" fontSize="xs" justify="space-between" mt={1.5}>{t21}{t22}</HStack>;
        $[53] = t21;
        $[54] = t23;
      } else {
        t23 = $[54];
      }
      if ($[55] !== t20 || $[56] !== t23) {
        t12 = <Box width="full">{t20}{t23}</Box>;
        $[55] = t20;
        $[56] = t23;
        $[57] = t12;
      } else {
        t12 = $[57];
      }
      T0 = VStack;
      t3 = 3;
      t4 = "full";
      t5 = STEPS.map((step, i) => {
        const status = currentIndex > step.statusIndex ? "done" : currentIndex === step.statusIndex ? "active" : "pending";
        return <Box key={step.title} width="full"><HStack align="flex-start" bg={status === "active" ? "orange.subtle/50" : "bg.subtle"} borderColor={status === "active" ? "orange.muted" : "border.subtle"} borderRadius="xl" borderWidth="1px" gap={4} opacity={status === "pending" ? 0.65 : 1} padding={5} transition="all 0.3s ease">{status === "pending" ? <><SkeletonCircle size="10" /><SkeletonText flexGrow={1} gap={3} noOfLines={2} /></> : <>{status === "done" ? <Circle bgColor="green.solid" color="white" size={10}><Icon asChild={true}><step.icon /></Icon></Circle> : <Circle borderColor="orange.muted" borderWidth="2px" size={10}><Spinner colorPalette="orange" size="sm" /></Circle>}<Box flex={1}><Heading size="sm"><Text as="span" color="fg.subtle" fontWeight="normal" mr={2}>{String(i + 1).padStart(2, "0")}</Text>{step.title}</Heading><Text color="fg.muted" fontSize="sm" mt={0.5}>{step.detail}</Text>{step.statusIndex === 2 && deck.slides.length > 0 && <Wrap gap={1} mt={2}><Badge colorPalette="green" size="sm" variant="subtle">{deck.slides.length} slides found</Badge>{deck.slides.map(_temp2)}</Wrap>}{step.statusIndex === 3 && status === "active" && <Wrap gap={1} mt={2}>{scoredSlides.length > 0 ? <><Badge colorPalette="purple" size="sm" variant="subtle">Scored {scoredSlides.length}</Badge>{scoredSlides.map(_temp3)}</> : <Text color="fg.subtle" fontSize="xs">Reading the whole deck before scoring…</Text>}</Wrap>}</Box></>}</HStack></Box>;
      });
    }
    $[2] = currentIndex;
    $[3] = deck.companyName;
    $[4] = deck.errorMessage;
    $[5] = deck.isFailed;
    $[6] = deck.pitchDeckId;
    $[7] = deck.slides;
    $[8] = progressPct;
    $[9] = reanalyze;
    $[10] = reanalyzing;
    $[11] = T0;
    $[12] = T1;
    $[13] = t10;
    $[14] = t11;
    $[15] = t12;
    $[16] = t13;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    T0 = $[11];
    T1 = $[12];
    t10 = $[13];
    t11 = $[14];
    t12 = $[15];
    t13 = $[16];
    t3 = $[17];
    t4 = $[18];
    t5 = $[19];
    t6 = $[20];
    t7 = $[21];
    t8 = $[22];
    t9 = $[23];
  }
  if (t13 !== Symbol.for("react.early_return_sentinel")) {
    return t13;
  }
  let t14;
  if ($[58] !== T0 || $[59] !== t3 || $[60] !== t4 || $[61] !== t5) {
    t14 = <T0 gap={t3} width={t4}>{t5}</T0>;
    $[58] = T0;
    $[59] = t3;
    $[60] = t4;
    $[61] = t5;
    $[62] = t14;
  } else {
    t14 = $[62];
  }
  let t15;
  if ($[63] !== T1 || $[64] !== t10 || $[65] !== t11 || $[66] !== t12 || $[67] !== t14 || $[68] !== t6 || $[69] !== t7 || $[70] !== t8 || $[71] !== t9) {
    t15 = <T1 gap={t6} marginX={t7} maxWidth={t8} padding={t9} width={t10}>{t11}{t12}{t14}</T1>;
    $[63] = T1;
    $[64] = t10;
    $[65] = t11;
    $[66] = t12;
    $[67] = t14;
    $[68] = t6;
    $[69] = t7;
    $[70] = t8;
    $[71] = t9;
    $[72] = t15;
  } else {
    t15 = $[72];
  }
  return t15;
}
function _temp3(slide_0) {
  return <Presence key={slide_0.pitchDeckSlideId} animationDuration="moderate" animationName={{
    _open: "scale-in, fade-in",
    _closed: "fade-out"
  }} present={true}><Badge colorPalette={ratingColorPalette(slide_0.ratingKey)} size="sm" variant="surface">{slide_0.classificationLabel}{slide_0.score != null ? ` · ${slide_0.score}` : ""}</Badge></Presence>;
}
function _temp2(slide) {
  return <Presence key={slide.pitchDeckSlideId} animationDuration="moderate" animationName={{
    _open: "fade-in",
    _closed: "fade-out"
  }} present={true}><Badge size="sm" variant="surface">{String(slide.position).padStart(2, "0")}{slide.classificationLabel ? ` · ${slide.classificationLabel}` : ""}</Badge></Presence>;
}
function _temp(s) {
  return s.isAudited;
}